import { Box, Card, Typography } from "@mui/material";
import React from "react";
export function DoubleBeanAndRoastedPepperChilli() {
  return (
    <Card sx={{ backgroundColor: "#bbbbbb" }}>
      <Typography variant="h1">
        Double Bean And Roasted Pepper Chilli
      </Typography>

      <Typography>
        <Typography variant="h3">Ingredients</Typography>2 onions, chopped{" "}
        <br></br>2 celery sticks, finely chopped<br></br>2 yellow or orange
        peppers, finely chopped<br></br>2 tbsp sunflower oil or rapeseed oil
        <br></br>2 x 460g jars roasted red peppers<br></br>2 tsp chipotle paste
        <br></br>2 tbsp red wine vinegar<br></br>1 tbsp cocoa powder<br></br>1
        tbsp dried oregano<br></br>1 tbsp sweet smoked paprika<br></br>2 tbsp
        ground cumin<br></br>1 tsp ground cinnamon<br></br>2 x 400g cans chopped
        tomatoes<br></br>
        400g can refried beans<br></br>3 x 400g cans kidney beans, drained and
        rinsed<br></br>2 x 400g cans black beans, drained and rinsed<br></br>
      </Typography>

      <Typography>
        Put the onions, celery and chopped peppers with the oil in your largest
        flameproof casserole dish or heavy-based saucepan, and fry gently over a
        low heat until soft but not coloured.<br></br>
        Drain both jars of peppers over a bowl to catch the juices. Put a
        quarter of the peppers into a food processor with the chipotle paste,
        vinegar, cocoa, dried spices and herbs. Whizz to a purée, then stir into
        the softened veg and cook for a few mins.<br></br>
        Add the tomatoes and refried beans with 1 can water and the reserved
        pepper juice. Simmer for 1 hr until thickened, smoky and the tomato
        chunks have broken down to a smoother sauce.<br></br>
        At this stage you can cool and chill the sauce if making ahead.
        Otherwise add the kidney and black beans, and the remaining roasted
        peppers, cut into bite-sized pieces, then reheat. (This makes a large
        batch, so once the sauce is ready it might be easier to split it between
        two pans when you add the beans and peppers.) Once bubbling and the
        beans are hot, season to taste and serve.<br></br>
      </Typography>
    </Card>
  );
}
